@if (mapIdArrayItems) {
  @for (select of mapIdArrayItems; track select.id) {
    <li class="edit-field-selected-options">
      @if (select.name) {
        <span [innerHtml]="select.name"></span>
      }

      <a (click)="unCheckMapId(select.id)">
        <mat-icon>
          close
        </mat-icon>
      </a>

      <div class="button-overlay"></div>
    </li>
  }
} @else if (arrayObject) {
  @for (select of arrayObject[arrayName]; track select) {
    @if (!crud.getDestroy(select)) {
      <li class="edit-field-selected-options">
        @if (select[valueProp]) {
          <span [innerHtml]="select[valueProp]"></span>
        }

        <a (click)="unCheckOption(select)">
          <mat-icon>
            close
          </mat-icon>
        </a>

        <div class="button-overlay"></div>
      </li>
    }
  }
}
